import { useEffect, useState } from "react";
import Header from "../../Components/common/Header";
import Layout from "../../Components/Website/Layout";
import { Card } from "react-bootstrap";
import "./ResaltExam.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faBook,
  faCircleCheck,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

export default function ResaltExam() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const resultData = location.state?.examresalt;
  const academacid = location.state?.academacid;
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (!resultData || !academacid) {
      navigate("/", { replace: true });
    }
  }, [resultData, academacid, navigate]);

  const handleShowDetails = (event) => {
    event.preventDefault();
    setShowDetails(true);
  };

  const isPassed = resultData?.passed;
  const percentage =
    typeof resultData?.percentage === "number"
      ? resultData.percentage
      : resultData && resultData.max_score > 0
      ? Math.round((resultData.score / resultData.max_score) * 100)
      : 0;

  return (
    <div className="ResaltExam">
      <Header />
      <Layout>
        <div className="resalt-container">
          {/* العنوان */}
          <Card className="resalt-card">
            <h1>نتيجة امتحان الوحدة الأولى</h1>
          </Card>

          {/* رسالة النجاح أو الفشل */}
          <Card
            className={`resalt-card-hed ${isPassed ? "success" : "failed"}`}
          >
            <h2>
              {isPassed
                ? "مبروك! لقد اجتزت الامتحان بنجاح"
                : "لم تحقق النسبة المطلوبة، لا تيأس، التعلم يحتاج وقتًا"}
              <FontAwesomeIcon
                icon={isPassed ? faCircleCheck : faTimesCircle}
                className="ms-2"
              />
            </h2>
          </Card>

          {/* تفاصيل النتيجة */}
          <Card
            className={`resalt-card-data ${isPassed ? "success" : "failed"}`}
          >
            <h3>{percentage}% من 100%</h3>
            <p>
              أجبت بشكل صحيح على <span>{resultData?.correct_answers}</span> من{" "}
              <span>{resultData?.all_questions}</span> سؤال
            </p>
            {!isPassed && (
              <p className="danger-text">
                {" "}
                اقتربت! فقط اجتز هذا الامتحان لتفتح الوحدة التالية.
              </p>
            )}
            {isPassed && (
              <p className="success-text">
                يمكنك الآن الانتقال إلى الوحدة التالية.
              </p>
            )}

            <div className="text-center mt-5">
              <Link to={`/learn/${academacid}`} className="btn-rejster py-1">
                العودة للصفحة الرئيسية <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
              <div className="text-end mt-5">
                <button
                  type="button"
                  className="btn-rejster"
                  onClick={handleShowDetails}
                >
                  عرض تفاصيل الإجابات <FontAwesomeIcon icon={faBook} />
                </button>
              </div>
            </div>
            {showDetails && (
              <Card className="resalt-card-data review-details mt-4">
                <h4>تفاصيل الإجابات</h4>
                {resultData?.answers?.length ? (
                  <ul className="answer-details-list">
                    {resultData.answers.map((item, index) => (
                      <li key={item.questionId ?? index} className="mb-3">
                        <strong>
                          سؤال {index + 1}
                          {item.questionText ? `: ${item.questionText}` : ""}
                        </strong>
                        <div>
                          إجابتك:{" "}
                          {item.studentAnswerText ?? item.answer ?? "—"}
                        </div>
                        <div>
                          الإجابة الصحيحة:{" "}
                          {item.correctAnswerText ?? item.correctAnswer ?? "—"}
                        </div>
                        <div
                          className={
                            item.manualReview
                              ? "text-warning"
                              : item.isCorrect
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {item.manualReview
                            ? "بانتظار مراجعة المعلم"
                            : item.isCorrect
                            ? "صحيحة"
                            : "خاطئة"}
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>لا توجد بيانات تفاصيل الإجابات للعرض.</p>
                )}
              </Card>
            )}
          </Card>
        </div>
      </Layout>
    </div>
  );
}
